module.exports = __webpack_public_path__ + "static/img/2.287bde6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/2.jpg
// module id = YU14
// module chunks = 5